class BoomProductCard extends HTMLElement {
    constructor() {
        super();
        this.uniqueId = this.getAttribute("data-unique-id") || this.dataset.uniqueId;  
    }

    connectedCallback() {
        this.form = this.querySelector('form');
        if (this.form) {
            this.form.addEventListener('submit', this._onFormSubmit.bind(this));
        }
        this._initVariantSelector();
    }

    _initVariantSelector() {
        this.selector = this.querySelector('[data-variant-selector]');
        if (!this.selector) return;

        this.variantData = this._parseVariantData();
        if (!this.variantData || this.variantData.length === 0) return;

        this.variantIdInput = this.querySelector('input[name="id"]');
        this.imageContainer = this.querySelector('[data-product-image-container]');
        this.priceElement = this.querySelector('[data-current-price]');
        this.comparePriceElement = this.querySelector('[data-compare-price]');
        this.cartButton = this.querySelector('button[type="submit"]');
        this.isInteractive = this.hasAttribute('data-variant-interactive');

        const radios = this.selector.querySelectorAll('input[type="radio"][xo-variant-id]');

        if (!this.isInteractive) {
            radios.forEach(radio => {
                radio.checked = false;
                radio.removeAttribute('checked');
                radio.disabled = true;
                radio.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }, true);
            });
            return;
        }

        radios.forEach(radio => {
            radio.addEventListener('change', this._onVariantChange.bind(this));
        });

        const checkedRadio = this.selector.querySelector('input[type="radio"][xo-variant-id]:checked');
        if (checkedRadio) {
            this._applyVariantFromRadio(checkedRadio);
        }
    }

    _parseVariantData() {
        const selector = this.querySelector('[data-variant-selector]');
        if (!selector) return null;
        const raw = selector.getAttribute('data-variants');
        if (!raw) return null;
        try {
            return JSON.parse(raw);
        } catch (e) {
            console.error('Failed to parse variant data:', e);
            return null;
        }
    }

    _onVariantChange(e) {
        this._applyVariantFromRadio(e.currentTarget);
    }

    _applyVariantFromRadio(radio) {
        const variantId = parseInt(radio.getAttribute('xo-variant-id'), 10);
        const variant = this.variantData.find(v => v.id === variantId);
        if (!variant) return;

        if (this.variantIdInput) {
            this.variantIdInput.value = variant.id;
        }

        if (this.cartButton) {
            this.cartButton.disabled = !variant.available;
        }

        if (this.isInteractive) {
            if (variant.image_url && this.imageContainer) {
                const imgs = this.imageContainer.querySelectorAll('img');
                imgs.forEach(img => {
                    img.src = variant.image_url;
                    img.removeAttribute('srcset');
                });
            }

            if (this.priceElement && variant.price_text) {
                this.priceElement.innerHTML = variant.price_text;
            }

            if (this.comparePriceElement) {
                if (variant.compare_price_text) {
                    this.comparePriceElement.innerHTML = variant.compare_price_text;
                    this.comparePriceElement.style.display = '';
                } else {
                    this.comparePriceElement.style.display = 'none';
                }
            }

            const labelValues = this.selector.querySelectorAll('.boom-variant-label-value[data-option-index]');
            if (labelValues.length > 0 && variant.options.length > 0) {
                labelValues.forEach(el => {
                    const idx = parseInt(el.getAttribute('data-option-index'), 10);
                    if (variant.options[idx] !== undefined) {
                        el.textContent = variant.options[idx];
                    }
                });
            }
        }
    }
    _onFormSubmit(e) {
        e.preventDefault();
        const form = this.form;
        const button = form.querySelector('button[type="submit"]');
        const text = button?.querySelector('.btn-text');
        const spinner = button?.querySelector('.btn-spinner');

        if (!button || button.disabled) return;

        button.disabled = true;
        if (text) text.style.visibility = 'hidden';
        spinner?.classList.remove('hidden');

        const xoStore = window.xoStore || (window.xobuildercomponents && window.xobuildercomponents.xoStore);
        const xoModalManager = window.xoModal || (window.xobuildercomponents && window.xobuildercomponents.xoModal);

        const formData = new FormData(form);
        const quantity = Number(formData.get('quantity')) || 1;
        
        const cartMiniId = document.querySelector('xo-cart-mini')?.id || 'xo-cart-mini';
        const sections = [cartMiniId].filter(Boolean);
        
        formData.append('sections', sections.join(','));
        formData.append('section_url', window.location.pathname);
            console.log("==进行请求==")
        fetch(`${window.Shopify.routes.root}cart/add`, {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (response.status === 404) throw new Error('Not found');
            if (response.status === 422) {
                return response.json().then(data => {
                    throw new Error(data.description || data.message);
                });
            }
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
        })
        .then(addData => {
            if (xoStore && typeof xoStore.set === 'function') {
                console.log("=addData=",addData.sections)
                xoStore.set('xo-cart', (prevState) => ({
                    ...prevState,
                    size: prevState.size + quantity,
                    sections: addData.sections || prevState.sections,
                    item: addData,
                    isAdded: true,
                    addIdLoading: '',
                    variantId: addData.variant_id || '',
                    productIdsForCartNotification: [`${addData.product_id}`]
                }))('xo-cart/addCartSuccess');
            } else {
                window.location.href = '/cart';
                return;
            }

            if (xoModalManager && typeof xoModalManager.open === 'function') {
                xoModalManager.open('cart');
            }

            button.focus({ preventScroll: true });
        })
        .catch(error => {
            console.error('Cart Refresh Error:', error);
            window.location.reload(); 
        })
        .finally(() => {
            if (button) button.disabled = false;
            if (text) text.style.visibility = 'visible';
            spinner?.classList.add('hidden');
        });
    }
}

if (!customElements.get('boom-product-card')) {
    customElements.define('boom-product-card', BoomProductCard);
}